/* eslint-disable react/prop-types */
import '@gogovan/entier-web-core/components/alert/alert.css';

import Head from 'next/head';
import '@/pages/styles.css';
import { Provider } from 'react-redux';
import store from '@/store';
import { StyledToastContainer } from '@gogovan/entier-web-core/components/alert';
import { LuxonLocalizationProvider } from '@gogovan/entier-web-core/form-components';
import { useTheme } from '@gogovan/entier-web-core/ext/mui/styles';
import { appWithTranslation } from 'next-i18next';
import { bootstrapBugsnag } from '@/bugsnag';
import { tntTheme } from '@/utilities/theme';
import { CustomThemeProvider } from '@gogovan/entier-web-core/base/theme';
import NextI18nextConfig from '../../next-i18next.config';

const App = ({ Component, pageProps }) => {
  const getLayout = Component.getLayout ?? ((page) => page);
  const theme = useTheme();

  const title = `${Component.title} | GoGoX Tracking`;

  bootstrapBugsnag();

  return (
    <Provider store={store}>
      <StyledToastContainer theme={theme} />
      <LuxonLocalizationProvider>
        <CustomThemeProvider theme={tntTheme}>
          <Head>
            <title>{title}</title>
          </Head>
          {getLayout(<Component {...pageProps} />)}
        </CustomThemeProvider>
      </LuxonLocalizationProvider>
    </Provider>
  );
};

export default appWithTranslation(App, NextI18nextConfig);
